import MIMESA from './company';
import { MIMESA_REMOVED_ROUTES } from './navigation';
import { MimesaCategoriesPage, MimesaProductsPage, MimesaSegmentsPage, MimesaStoreCheckPage, MimesaStoreProfilePage } from './pages';

/**
 * Mimesa's registration (see companies/README.md):
 *  - `pages`: base pages Mimesa replaces with its subclasses;
 *  - `remove`: base routes outside Mimesa's navigation allowlist (./navigation.js);
 *  - `extraRoutes`: Mimesa's own screens, e.g. its reports (./reports/README.md).
 */
const MimesaRegistration = Object.freeze({
    ...MIMESA,
    pages: Object.freeze({
        StoreCheck: MimesaStoreCheckPage,
        StoreProfile: MimesaStoreProfilePage,
        Products: MimesaProductsPage,
        Segments: MimesaSegmentsPage,
    }),
    remove: MIMESA_REMOVED_ROUTES,
    // { key, path, screen, guard?, component }: `screen` must be in MIMESA_SCREENS (or
    // navigation.extraNav) so the access model lets users in.
    extraRoutes: Object.freeze([
        // Product categories: Mimesa manages them itself (Mary's come from her catalog).
        { key: 'Categories', path: '/dashboard/products/categories', screen: 'categories', guard: 'categories', component: MimesaCategoriesPage },
    ]),
});

export default MimesaRegistration;
